import { useLanguage } from "@modules/language/hooks/useLanguage"
import { Language } from "@modules/language/utils/languageUtils"
import { countries, ICountry, TCountryCode } from "countries-list"
import { useEffect, useState } from "react"

export const countriesEntries = Object.entries(countries) as [TCountryCode, ICountry][]

export type CountryItem = {
  label: string
  code: string
  phone: number[]
}

const WorldLocalesData = {
  fr: () => import("world_countries_lists/data/countries/fr/world.json"),
  en: () => import("world_countries_lists/data/countries/en/world.json"),
  de: () => import("world_countries_lists/data/countries/de/world.json"),
  it: () => import("world_countries_lists/data/countries/it/world.json"),
  es: () => import("world_countries_lists/data/countries/es/world.json"),
  pt: () => import("world_countries_lists/data/countries/pt/world.json"),
  el: () => import("world_countries_lists/data/countries/el/world.json"),
  is: () => import("world_countries_lists/data/countries/en/world.json"),
  da: () => import("world_countries_lists/data/countries/da/world.json"),
  nl: () => import("world_countries_lists/data/countries/nl/world.json"),
  br: () => import("world_countries_lists/data/countries/pt/world.json"),
  ko: () => import("world_countries_lists/data/countries/ko/world.json"),
}
const CountriesLocalesData = {
  fr: () => import("world_countries_lists/data/countries/fr/countries.json"),
  en: () => import("world_countries_lists/data/countries/en/countries.json"),
  de: () => import("world_countries_lists/data/countries/de/countries.json"),
  it: () => import("world_countries_lists/data/countries/it/countries.json"),
  es: () => import("world_countries_lists/data/countries/es/countries.json"),
  pt: () => import("world_countries_lists/data/countries/pt/countries.json"),
  el: () => import("world_countries_lists/data/countries/el/countries.json"),
  is: () => import("world_countries_lists/data/countries/en/countries.json"),
  da: () => import("world_countries_lists/data/countries/da/countries.json"),
  nl: () => import("world_countries_lists/data/countries/nl/countries.json"),
  br: () => import("world_countries_lists/data/countries/pt/countries.json"),
  ko: () => import("world_countries_lists/data/countries/ko/countries.json"),
}

export const useCountrySubdivisionsListArray = (): CountryItem[] => {
  const [countrySubdivisionsList, setCountrySubdivisionsListList] = useState<CountryItem[]>([])

  const language = useLanguage()

  useEffect(() => {
    const locale = WorldLocalesData[language] ? language : Language.ENGLISH_US

    WorldLocalesData[locale]()
      .then((res) => {
        setCountrySubdivisionsListList(
          res.default
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((country) => {
              const countryPhoneCode = countries[country.alpha2.toUpperCase() as TCountryCode].phone
              return { code: country.alpha2.toUpperCase(), label: country.name, phone: countryPhoneCode }
            }),
        )
      })
      .catch((error) => console.log("Error reading country list", error))
  }, [language])

  return [
    ...countrySubdivisionsList,
    {
      code: "XK",
      label: "Kosovo",
      phone: [383],
    }, // Kosovo is missing in the package world_countries_lists
  ]
}

export const useCountriesListArray = (): CountryItem[] => {
  const [countriesList, setCountriesList] = useState<CountryItem[]>([])

  const language = useLanguage()

  useEffect(() => {
    const locale = CountriesLocalesData[language] ? language : Language.ENGLISH_US

    CountriesLocalesData[locale]()
      .then((res) => {
        setCountriesList(
          res.default
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((country) => {
              const countryPhoneCode = countries[country.alpha2.toUpperCase() as TCountryCode].phone
              return { code: country.alpha2.toUpperCase(), label: country.name, phone: countryPhoneCode }
            }),
        )
      })
      .catch((error) => console.log("Error reading country list", error))
  }, [language])

  return [
    ...countriesList,
    {
      code: "XK",
      label: "Kosovo",
      phone: [383],
    }, // Kosovo is missing in the package world_countries_lists
  ]
}
